import React, { Dispatch, SetStateAction, useRef } from 'react';
import { ATTRACTION, Top } from '../../pages/[slug]/[slug2]';
import Image from 'next/image';
import { useEffect, useState } from 'react';

import LocationMap from '../../components/Attraction/locationmap';

import styled from 'styled-components';
import dynamic from 'next/dynamic';
import PageHeroSlider from '../../components/Attraction/PageHeroSlider';
import { Rating } from 'react-simple-star-rating';
import FeaturedNav from '../../components/Attraction/featuredNav';
import TopBar from '../../components/Attraction/topBar';
import TopTip from '../../components/Attraction/topTip';
import AddTopTipModal from '../../components/Attraction/AddTopTipModal';

import { useRouter } from 'next/router';

const MARKDOWN = dynamic(() => import('../../utils/react-markdown'));
const StyleMarkdown = styled.div`
  line-height: 2rem;
  color: #333333;
  h2 {
    margin-bottom: 10px;
    font-size: 26px;
    font-weight: 600;
    @media (max-width: 1024px) {
      font-size: 20px;
    }
    @media (max-width: 640px) {
      font-size: 18px;
    }
  }
  h3 {
    font-size: 20px;
    font-weight: 500;
    @media (max-width: 1024px) {
      font-size: 18px;
    }
    @media (max-width: 640px) {
      font-size: 16px;
    }
    @media (max-width: 540px) {
      font-size: 14px;
    }
  }
  a {
    color: #38bdf8 !important;
    text-decoration: underline;
  }
  p {
    font-size: 16px;
    font-weight: 400;
    @media (max-width: 1024px) {
      font-size: 14px;
    }
    @media (max-width: 640px) {
      font-size: 12px;
    }
    @media (min-width: 1280px) {
      font-size: 16px;
    }
  }
  .center {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  .cta-two-tone {
    background-image: url('https://res.cloudinary.com/see-sight-tours/image/upload/v1669883122/dark-back_tqnwfs.png');
    width: 50%;

    @media (max-width: 1200px) {
      width: 70%;
    }
    @media (max-width: 700px) {
      width: 100%;
    }
    min-height: 200px;
    border-radius: 20px;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    p {
      margin-top: 1rem;
      color: white;
      padding: 0 0.5rem;
      font-size: 26px;
      text-align: center;
      min-height: 50%;
      position: relative;
      @media (max-width: 900px) {
        text-align: center;
        font-size: 22px;
      }
      @media (max-width: 500px) {
        text-align: center;
        height: 80%;
        font-size: 20px;
      }
    }
    .button-container {
      width: 100%;
      display: flex;
      background-image: url('https://res.cloudinary.com/see-sight-tours/image/upload/v1669883122/light-water_pjgzcg.png');
      background-position: center;
      justify-content: center;
      position: relative;
      min-height: 30%;
      border-radius: 0px 0px 20px 20px;
      @media (max-width: 500px) {
        height: 20%;
      }
      a {
        position: absolute;
        top: -35%;
        background: #d14f4d;
        border-radius: 20px;
        width: 45%;
        height: 70%;
        text-decoration: none;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: white !important;
        font-size: 20px;
        font-weight: bold;
        @media (max-width: 500px) {
          width: 60%;
          height: 60%;
          font-size: 16px;
        }
        &:hover {
          background: #fd3f3c;
        }
      }
    }
  }
`;
interface IProps {
  attraction: ATTRACTION;
  handleSubmit: () => Promise<void>;
  toptipText: string;
  setToptipText: Dispatch<SetStateAction<string>>;
  updateTopTip: (id: string, likes: number, dislikes: number) => Promise<void>;
  isModalOpen: boolean;
  top: Top[];
  setTop: Dispatch<SetStateAction<Top[]>>;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}

export const AttractionPage = ({
  attraction,
  handleSubmit,
  toptipText,
  setToptipText,
  updateTopTip,
  isModalOpen,
  setIsModalOpen,
  top
}: IProps) => {
  const [showFullDescription, setShowFullDescription] = useState(false);

  const handleSeeMoreDescription = () => {
    setShowFullDescription(!showFullDescription);
  };
  const [openDropdownIndex, setOpenDropdownIndex] = useState<string | null>(
    null
  );
  const dropdownRefs = useRef<Map<string, HTMLDivElement | null>>(new Map());

  const handleClickOutside = (event: MouseEvent) => {
    if (openDropdownIndex !== null) {
      const ref = dropdownRefs.current.get(openDropdownIndex);
      if (ref && !ref.contains(event.target as Node)) {
        setOpenDropdownIndex(null);
      }
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openDropdownIndex]);

  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (router.query.showPriceModal === 'true') {
      setIsOpen(true); // Open the modal when the query is present
    }
  }, [router.query.showPriceModal]);
  useEffect(() => {
    const handleBackButton = () => {
      localStorage.setItem(
        'referringPage',
        `${window.location.origin}${router.asPath}`
      );
    };

    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);
  const hours = attraction.hours_of_operation
    ? attraction.hours_of_operation
        .split('\n')
        .map(line => line.trim().replace(/^\*+|\*+$/g, ''))
    : [];

  const {
    name,
    long_description,
    hours_of_operation,
    short_description,
    address,
    images
  } = attraction || ({} as ATTRACTION);

  return (
    <div className="w-[90%] lg:w-[85%] 3xl:w-[70%] max-w-[1750px] mx-auto sm:mt-4">
      <div
        className="flex sm:hidden font-semibold text-[14px] leading-[19.5px] gap-4 py-4 cursor-pointer hover:underline text-black13 hover:text-primary"
        onClick={() => {
          router.back();
        }}
      >
        <Image
          src={'/black-left-arrow.svg'}
          alt="left arrow"
          width={7}
          height={8}
        />
        Back
      </div>
      <h1
        className="md:px-[5%] md:pl-0 text-[20px] xl:text-[32px] font-extrabold mb-2 "
        id="what-you-will-see"
      >
        {name}
      </h1>
      {attraction?.google_data?.rating ? (
        <span className="flex items-center gap-1">
          <Rating
            initialValue={attraction?.google_data?.rating}
            allowFraction={true}
            disableFillHover={true}
            fillColor="orange"
            emptyColor="#9B9B9B"
            readonly={true}
            SVGstyle={{
              display: 'inline-block'
            }}
            size={15}
          />
          <span className="font-semibold">
            {attraction?.google_data?.rating}
          </span>
          <span>({attraction?.google_data?.user_ratings_total})</span>
        </span>
      ) : (
        <div className="mt-4"></div>
      )}
      <PageHeroSlider
        photos={images.map(item => {
          return item.file.url;
        })}
        title={name}
      />
      <FeaturedNav attraction={attraction} top={top} />
      <TopBar
        isModalOpen={isOpen}
        setIsModalOpen={setIsOpen}
        attraction={attraction}
        headings={['Overview', 'Top Tips', 'Reviews']}
      />

      <h2
        id="overview"
        className="md:pl-0 text-[20px] xl:text-[24px] font-semibold mt-8 mb-2 "
      >
        Overview
      </h2>

      {short_description ? (
        <div className="text-justify xl:text-[16px] pr-2 overflow-hidden leading-[2rem]">
          {showFullDescription ? (
            <>
              {short_description}
              <span
                className="font-semibold cursor-pointer"
                onClick={handleSeeMoreDescription}
              >
                {' '}
                ...see less
              </span>
            </>
          ) : (
            <>
              {short_description?.length > 550 ? (
                <>
                  {short_description.slice(0, 550)}
                  <span
                    className="font-semibold cursor-pointer"
                    onClick={handleSeeMoreDescription}
                  >
                    {' '}
                    ...see more
                  </span>
                </>
              ) : (
                short_description
              )}
            </>
          )}
        </div>
      ) : (
        <h2>
          Explore this amazing attraction and discover what makes it a
          must-visit. Stay tuned for more details!
        </h2>
      )}
      {attraction.hours_of_operation && (
        <div>
          <h2
            id="OpeningHours"
            className="md:pl-0 text-[20px] xl:text-[24px] font-semibold mt-8 mb-2 "
          >
            Opening Hours
          </h2>
          <ul style={{ paddingLeft: '1.5rem', listStyleType: 'disc' }}>
            {(attraction.hours_of_operation || '')
              .split('\n')
              .map((line: string, idx: number) => (
                <li key={idx}>{line.trim().replace(/^\*+|\*+$/g, '')}</li>
              ))}
          </ul>
        </div>
      )}

      <div id="top-tips">
        <TopTip
          setIsModalOpen={setIsModalOpen}
          top={top}
          updateTopTip={updateTopTip}
        />
      </div>
      {isModalOpen && (
        <AddTopTipModal
          toptipText={toptipText}
          setToptipText={setToptipText}
          handleSubmit={handleSubmit}
          top={top}
          setIsModalOpen={setIsModalOpen}
        />
      )}
      <div>
        <LocationMap
          name={name}
          address={address}
          data={{ hours_of_operation, address }}
        />
        <div id="Attractions" className="">
          <StyleMarkdown id="long-description" className="mt-5 mb-8">
            {long_description && <MARKDOWN content={long_description} />}
          </StyleMarkdown>
        </div>
      </div>

      {/* Buy Ticket z-index should be 1200 and higher as it should be visible always on mobile bottom bar*/}
      {!isOpen && attraction?.tickets && (
        <div className="z-[1200] fixed  md:hidden px-[2%]    bg-white    items-center flex justify-between bottom-0 right-0  w-full py-4 rounded-md    text-white shadow-2xl shadow-offset-md   ">
          <button
            className="bg-primary w-full text-white min-w-[30%]  px-4 py-2 rounded-lg"
            id="mobile-check-dates"
            onClick={() => setIsOpen(true)}
          >
            {' '}
            Buy Ticket
          </button>
        </div>
      )}
    </div>
  );
};
